import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SnookerScoreboardBaseComponent } from '../scoreboard-base/snooker-scoreboard-base.component';

@Component({
    selector: 'ms-snooker-scoreboard-header',
    templateUrl: './snooker-scoreboard-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnookerScoreboardHeaderComponent extends SnookerScoreboardBaseComponent {}
